<div class="progress-stages">
  <div class="d-flex">
    <div *ngFor="let step of steps; let i = index; let last = last; trackBy: trackByIndex"
         class="stage-item"
         [class.stage-completed]="step.status === Status.Completed"
         [class.stage-active]="step.status === Status.Active"
         [class.stage-pastdue]="step.status === Status.PastDue"
         [class.stage-pending]="step.status === Status.Pending">
      <div class="stage-dot" [matTooltip]="step.label + ': ' + statusLabel(step)">
        <i *ngIf="step.status === Status.Completed" class="fa fa-check"></i>
        <span *ngIf="step.status !== Status.Completed">{{ i + 1 }}</span>
      </div>
      <div class="stage-label">{{ step.label }}</div>
      <div *ngIf="!last" class="stage-connector"
           [class.connector-completed]="step.status === Status.Completed"
           [class.connector-pending]="step.status !== Status.Completed">
      </div>
    </div>
  </div>
</div>
